// src/encounter/intelligence/next-step-classes.ts
//
// The Next step card's own class names: Signal DS / Tailwind named utilities only (check-no-arbitrary-classes). The
// shared card frame, title, meta and state lines come from explain-card-classes.ts.
export const N = {
  // N-01: the Read line wraps and is never truncated.
  readLine: 'm-0 text-2xs font-normal text-text-secondary whitespace-normal break-normal wrap-normal',
  items: 'm-0 p-0 list-none flex flex-col gap-3',
  item: 'flex flex-col gap-0.5 py-1',
  itemTitle: 'm-0 text-xs font-semibold',
  evidence: 'm-0 text-2xs font-normal text-text-secondary break-normal wrap-normal',
  link: 'text-brand-primary no-underline hover:underline',
  actions: 'flex flex-wrap items-center gap-2',
  more: 'inline-flex h-6 w-6 items-center justify-center rounded-sm border-0 bg-transparent p-0 text-text-secondary cursor-pointer disabled:cursor-default',
  /** The positioned host the "More" menu portals into (rail-menu.tsx). */
  moreHost: 'relative inline-flex',
  /** Width and padding over the DS AnchoredPopover surface (its surface, border and shadow are the DS's own). */
  menu: 'min-w-32 p-1',
  menuItem: 'w-full rounded-sm border-0 bg-transparent px-3 py-1.5 text-left text-xs leading-4 text-text-primary cursor-pointer hover:bg-grey-100',
  reasonRow: 'flex flex-col gap-1',
} as const;
